<template>
  <div class="recharge-amount">
    <el-radio-group v-model="amount">
      <el-radio :label="10000">10,000元</el-radio>
      <el-radio :label="20000">20,000元</el-radio>
      <el-radio :label="50000">50,000元</el-radio>
      <el-radio :label="100000">100,000元</el-radio>
      <el-radio :label="0">其他</el-radio>
    </el-radio-group>
    <div class="recharge-result">
      <div class="amount-input" v-show="amount == 0">输入金额：<el-input v-model="val" size="small" maxlength="12" @change="amountChange"></el-input>元</div>
      <span class="recharge-text" v-show="account.precharge > 0">账户待还款：<span class="text-red">{{account.precharge | formatNum(',.2')}}</span>元</span>
      <span class="recharge-text">充值后余额：<span class="text-red">{{balance | formatNum(',.2')}}</span>元</span>
    </div>
  </div>
</template>
<script>
  import math from 'common/math.js';
  import {numUtils} from 'common/utils.js';
  import {getAccountBalanceCharge} from '../utils/api.js';
  export default {
    name: 'recharge-amount',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: [String, Number]
    },
    data() {
      return {
        account: {
          cash: 0, // 现金余额
          precharge: 0 // 欠款
        },
        amount: 0,
        val: 0
      }
    },
    filters: {
      formatNum: numUtils.formatNum
    },
    computed: {
      balance() {
        let amount = this.amount == 0 ? +this.val : this.amount;
        return math.add(math.add(amount, -this.account.precharge), this.account.cash);
      }
    },
    watch: {
      amount(v) {
        this.$emit('change', v);
      }
    },
    created() {
      this.getBalance();
    },
    methods: {
      async getBalance() {
        let result = await getAccountBalanceCharge();
        if (result) {
          Object.assign(this.account, result);
        }
      },
      amountChange() {
        this.$emit('change', +this.val);
      }
    }
  }
</script>
<style lang="scss">
  .recharge-amount {
    padding: 0 10px;
    width: 550px;
    font-size: 12px;
    .recharge-result {
      padding: 10px;
      margin-top: 20px;
      line-height: 30px;
      border: 1px solid #ddd;
      background: #f8f9fa;
      .amount-input {
        display: inline-block;
      }
    }
    .el-input {
      display: inline-block;
      width: 110px;
    }
    .recharge-text {
      display: inline-block;
      margin-left: 24px;
      .text-red {
        color: #ff9800;
      }
    }
  }
</style>